export function delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
export function withTimeout(promise, timout, errorMessage = "Promise timed out") {
    const timeout = new Promise((_, reject) => {
        setTimeout(() => {
            reject(new Error(errorMessage));
        }, timout);
    });
    return Promise.race([promise, timeout]);
}
export function getRandomUIDLegacy() {
    let uid = "";
    for (let i = 0; i < 16; i++) {
        uid += Math.floor(Math.random() * 255).toString(16).padStart(2, "0");
    }
    return uid;
}
export function getRandomUID() {
    if (self.crypto && self.crypto.randomUUID)
        return self.crypto.randomUUID();
    else
        return getRandomUIDLegacy();
}
export function assert(condition, message) {
    if (!condition)
        throw new Error(message || "Assertion failed");
}
